"use client";

import { TCommunityFeedPost } from "@/types/post";
import { ChevronLeft, ChevronRight, Pin } from "lucide-react";
import { useState } from "react";
import FeedPost from "./feed-post";
import { FeedPostUIType } from "./feed-post-ui";

interface PinnedPostsCarouselProps {
	posts: TCommunityFeedPost[];
	showPinnedText?: boolean;
	uiType?: FeedPostUIType;
}

const PinnedPostsCarousel = ({
	posts,
	showPinnedText = true,
	uiType,
}: PinnedPostsCarouselProps) => {
	const [currentIndex, setCurrentIndex] = useState(0);

	const goToPrevious = () => {
		const isFirstSlide = currentIndex === 0;
		const newIndex = isFirstSlide ? posts.length - 1 : currentIndex - 1;
		setCurrentIndex(newIndex);
	};

	const goToNext = () => {
		const isLastSlide = currentIndex === posts.length - 1;
		const newIndex = isLastSlide ? 0 : currentIndex + 1;
		setCurrentIndex(newIndex);
	};

	return (
		<div className="relative">
			<div className="flex items-center justify-between">
				{showPinnedText && (
					<div className="flex items-center gap-2">
						<Pin className="h-4 w-4" />
						<span className="text-sm font-medium">Pinned</span>
					</div>
				)}
				<div className="flex items-center justify-center">
					<button onClick={goToPrevious} className="p-2">
						<ChevronLeft />
					</button>
					<span className="text-sm font-medium">
						{currentIndex + 1}/{posts.length}
					</span>
					<button onClick={goToNext} className="p-2">
						<ChevronRight />
					</button>
				</div>
			</div>
			<div>
				<FeedPost post={posts[currentIndex]} uiType={uiType} />
			</div>
		</div>
	);
};

export default PinnedPostsCarousel;
